<svelte:options accessors/>
<script lang="ts">
    import NauiButton from "../naui/atoms/NauiButton.svelte";
    import NauiFloatingAction from "../naui/components/NauiFloatingAction.svelte";
    import FechaItem from "./components/FechaItem.svelte";
    import NauiSlideOver from "../naui/layout/NauiSlideOver.svelte";
    import NauiSelect from "../naui/atoms/NauiSelect.svelte";
    import NauiExpansionPanel from "../naui/layout/NauiExpansionPanel.svelte";
    import NauiCheckbox from "../naui/atoms/NauiCheckbox.svelte";
    import {onMount} from "svelte";
    import {createEventDispatcher} from "svelte";
    import type {IFechaItem} from "../interfaces/fecha-item.interface";
    import moment from "moment";
    import type {IDateRule, IDateRuleItem} from "../interfaces/date-rule.interface";

    const dispatch = createEventDispatcher();

    export let list: Array<IFechaItem> = [];
    export let zones: Array<any> = [];
    export let asesores: Array<any> = [];
    export let filteredAsesores: Array<any> = [];
    export let filteredAsesoresAux: Array<any> = [];
    export let filteredGun: Array<any> = [];
    export let filteredGunAux: Array<any> = [];
    export let filteredGA: Array<any> = [];
    export let  filteredGAAux: Array<any> = [];
    export let filteredAsistentes: Array<any> = [];
    export let filteredAsistentesAux: Array<any> = [];
    export let asistentes: Array<any> = [];
    
   
    export let gun: Array<any> = [];
    
    export let ga: Array<any> = [];
    
    export let rules: Array<IDateRule> = [];
    export let editable: boolean = false;
    export let searchVal: string;

    let selectedZone: any;
    let selectedDate: any;
    let open = false;
    let roles = {
        gun: false,
        ga: false,
        asesor: false,
        asistente: false
    }
    export let modal;


    function edit(event) {
        const find = list.find(i => i.slug === event.detail);
        selectedDate = find;
        filteredGA = (ga || []).map(i => ({
            ...i,
            selected: find ? !!find.items.find(_ => _.id === i.id) : false
        }));
        filteredGun = (gun || []).map(i => ({
            ...i,
            selected: find ? !!find.items.find(_ => _.id === i.id) : false
        }));
        filteredAsesores = (asesores || []).map(i => ({
            ...i,
            selected: find ? !!find.items.find(_ => _.id === i.id) : false
        }));
        filteredAsistentes = (asistentes || []).map(i => ({
            ...i,
            selected: find ? !!find.items.find(_ => _.id === i.id) : false
        }));
        open = true;
    }

    function filterByZone() {
        if (selectedZone) {
            filteredAsistentes.forEach((i: any) => {
                i.hidden = i?.zone ? i.zone.id !== selectedZone : true;
            });
            filteredAsesores.forEach((i: any) => {
                i.hidden = i?.zone ? i.zone.id !== selectedZone : true;
            });
            filteredGun.forEach((i: any) => {
                i.hidden = i?.zone ? i.zone.id !== selectedZone : true;
            });
            filteredGA.forEach((i: any) => {
                i.hidden = i?.zone ? i.zone.id !== selectedZone : true;
            });
        } else {
            filteredAsistentes.forEach((i: any) => {
                i.hidden = false;
            });
            filteredAsesores.forEach((i: any) => {
                i.hidden = false;
            });
            filteredGun.forEach((i: any) => {
                i.hidden = false;
            });
            filteredGA.forEach((i: any) => {
                i.hidden = false;
            });
        }
        filteredGun = filteredGun;
        filteredAsesores = filteredAsesores;
        filteredAsistentes = filteredAsistentes;
        filteredGA = filteredGA;
    }

    onMount(async () => {
        asistentes = (asistentes || []).map(i => ({
            ...i,
            hidden: false,
            selected: false
        }))
        filteredAsistentes = asistentes;
        filteredAsistentesAux = orderAndFilterRepresentative(filteredAsistentes, "");

        asesores = (asesores || []).map(i => ({
            ...i,
            hidden: false,
            selected: false
        }))
        filteredAsesores = asesores;
        filteredAsesoresAux = orderAndFilterRepresentative(filteredAsesores, "");
        
        gun = (gun || []).map(i => ({
            ...i,
            hidden: false,
            selected: false
        }))
        filteredGun = gun;
        filteredGunAux = orderAndFilterRepresentative(filteredGun, "")

        ga = (ga || []).map(i => ({
            ...i,
            hidden: false,
            selected: false
        }))
        filteredGA = ga;
        filteredGAAux = orderAndFilterRepresentative(filteredGA, "")

    });

    function saveItems(): void {
        if (selectedDate) {
            selectedDate.items = [
                ...filteredAsistentesAux.filter(a => a.selected).map(a => ({
                        id: a.id,
                        name: a.user.full_name,
                    role: a.role
                    })),
                ...filteredAsesoresAux.filter(a => a.selected).map(a => ({
                        id: a.id,
                        name: a.user.full_name,
                    role: a.role
                    })),
                ...filteredGunAux.filter(a => a.selected).map(a => ({
                        id: a.id,
                        name: a.user.full_name,
                    role: a.role
                    })),
                ...filteredGAAux.filter(a => a.selected).map(a => ({
                        id: a.id,
                        name: a.user.full_name,
                    role: a.role
                }))
            ]
            selectedDate = selectedDate
            const index = list.findIndex(a => a.slug === selectedDate.slug);
            list[index] = selectedDate;
        }
        open = false;
    }

    function next() {
        emit('next');
    }

    function back() {
        emit('back');
    }

    function emit(action: string) {
        if (validate()) {
            dispatch(action, {
                list
            });
        } else {
            modal.openModal({
                closeButton: false,
                closeOnEsc: true,
                closeOnOuterClick: true,
                message: `<p>Alguna de las fechas no es valida.</p>`,
                button: 'ACEPTAR'
            });
        }
    }

    function validate() {
        if (rules.length > 0) {
            return rules.every((r: IDateRule) => {
                const find = list.find(f => f.slug === r.key);
                if (!find) {
                    return false;
                }
                const date = moment(find.date, 'YYYY-MM-DD');
                if (!date.isValid()) {
                    return false
                }
                return r.items.every((i: IDateRuleItem) => {
                    const _find = list.find(f => f.slug === i.key);
                    if (!_find) {
                        return false;
                    }
                    const _date = moment(_find.date, 'YYYY-MM-DD');
                    if (!_date.isValid()) {
                        return false;
                    }
                    switch (i.comparator) {
                        case "eq":
                            return date === _date;
                        case "lt":
                            return date < _date;
                        case "lte":
                            return date <= _date;
                        case "gt":
                            return date > _date;
                        case "gte":
                            return date >= _date;
                        default:
                            return false;
                    }
                });
            });
        } else {
            return true;
        }
    }

    function orderAndFilterRepresentative(filteredAsesores: Array<any>, searchValue) {
        if(searchValue){
            filteredAsesores = filteredAsesores.filter(
            item => item.user.full_name.toLowerCase().indexOf(
                searchValue.toLowerCase()
                ) !== -1
            );

            return filteredAsesores;
        }
        filteredAsesores = filteredAsesores
            .sort(alphabetically(true))
            .filter(isValid);
        
            console.log(
                filteredAsesores.forEach((a) => console.log(a.user.full_name))
            );
        return filteredAsesores;
    }

    function alphabetically(ascending: boolean) {
        return function (a, b) {
            a = a.user.full_name;
            b = b.user.full_name;
            // equal items sort equally
            if (a === b) {
                return 0;
            }

            // nulls sort after anything else
            if (a === null) {
                return 1;
            }
            if (b === null) {
                return -1;
            }

            // otherwise, if we're ascending, lowest sorts first
            if (ascending) {
                return a < b ? -1 : 1;
            }

            // if descending, highest sorts first
            return a < b ? 1 : -1;
        };
    }

    function isValid(value: any) {
        return (
            value.user.full_name != null &&
            value.user.full_name != undefined &&
            value.user.full_name != ""
        );
    }

    document.addEventListener("keyup", (e) => {
         if (e.target.matches("#search1")) {
            $: filteredAsesoresAux = orderAndFilterRepresentative(filteredAsesores, e.target.value);
        } 
        if (e.target.matches("#search2")) {
            $: filteredGunAux = orderAndFilterRepresentative(filteredGun, e.target.value);
        } 
        if (e.target.matches("#search3")) {
            $: filteredAsistentesAux = orderAndFilterRepresentative(filteredAsistentes, e.target.value);
        } 
        if (e.target.matches("#search4")) {
            $: filteredGAAux = orderAndFilterRepresentative(filteredGA, e.target.value);
        } 
        if (e.target.value){
                console.log(e.target.value.toLowerCase());
        }
    });
</script>

<fieldset>
    <legend>Fechas clave</legend>

    <table class="naui-table straps">
        <thead>
            <tr>
                <th style="min-width: 300px">
                    <div>Nombre fecha</div>
                </th>
                <th>
                    <div>Fecha límite</div>
                </th>
                <th style="min-width: 250px;">
                    <div>Responsable a notificar</div>
                </th>
            <th></th>
            </tr>
        </thead>
        <tbody>
            {#each list as item (item.slug)}
                <FechaItem
                    bind:data={item}
                    isDisabled={!editable}
                    on:edit={edit}
                />
            {/each}
        </tbody>
    </table>
    {#if editable}
        <div class="box-l sx-ii mt-2">
            <NauiButton
                caption="REGRESAR"
                mode="outline"
                color="accent"
                on:click={back}
            />
            <NauiButton
                caption="CONTINUAR"
                mode="solid"
                color="accent"
                on:click={next}
            />
        </div>
    {/if}
    {#if editable}
        <NauiFloatingAction>
            <NauiButton
                caption="GUARDAR"
                mode="solid"
                icon="save"
                color="accent"
                on:click={() => dispatch("save", { list })}
            />
        </NauiFloatingAction>
    {/if}
</fieldset>
<NauiSlideOver bind:open title="Asignar responsables a notificar">
    <div class="mb-1">
        <NauiSelect
            label="Zona"
            bind:value={selectedZone}
            on:change={filterByZone}
            options={zones}
        />
    </div>
    <div class="mb-1">
        <NauiExpansionPanel>
            <div slot="header">
                <div class="box-l sx-ii">
                    <NauiCheckbox
                        bind:value={roles.asesor}
                        on:change={() => {
                            filteredAsesoresAux.forEach(
                                (u) => (u.selected = roles.asesor)
                            );
                            filteredAsesoresAux = [...filteredAsesoresAux];
                        }}
                    />
                    <strong class="ml-ii">Asesores comerciales </strong>
                </div>
            </div>
            <div>
                <div>
                    <input
                        id="search1"
                        class="naui-input search-input"
                        placeholder="Buscar por nombre"
                        type="text"
                    />

                    {#each filteredAsesoresAux as item}
                        {#if !item?.hidden}
                            <div id="filter1" class="asesor">
                                <NauiCheckbox
                                    label={item?.user?.full_name}
                                    bind:value={item.selected}
                                />
                            </div>
                        {/if}
                    {/each}
                </div>
            </div>
        </NauiExpansionPanel>
    </div>

    <div class="mb-1">
        <NauiExpansionPanel>
            <div slot="header">
                <div class="box-l sx-ii">
                    <NauiCheckbox
                        bind:value={roles.gun}
                        on:change={() => {
                            filteredGunAux.forEach(
                                (u) => (u.selected = roles.gun)
                            );
                            filteredGunAux = [...filteredGunAux];
                        }}
                    />
                    <strong class="ml-ii">Gerentes Unidad de Negocio</strong>
                </div>
            </div>
            <div>
                <input
                id="search2"
                class="naui-input search-input"
                placeholder="Buscar por nombre"
                type="text"
            />
            
            {#each filteredGunAux as item}
                {#if !item?.hidden}
                <div id="filter1" class="asesor">
                    <NauiCheckbox
                        label={item?.user?.full_name}
                        bind:value={item.selected}
                    />
                </div>
                {/if}
            {/each}
        </div>
        </NauiExpansionPanel>
    </div>
    <div class="mb-1">
        <NauiExpansionPanel>
            <div slot="header">
                <div class="box-l sx-ii">
                    <NauiCheckbox
                        bind:value={roles.ga}
                        on:change={() => {
                            filteredGAAux.forEach((u) => (u.selected = roles.ga));
                            filteredGAAux = [...filteredGAAux];
                        }}
                    />
                    <strong class="ml-ii">Gerentes Aprobadores</strong>
                </div>
            </div>
            <div>
                <input
                id="search4"
                class="naui-input search-input"
                placeholder="Buscar por nombre"
                type="text"
            />
            {#each filteredGAAux as item}
                {#if !item?.hidden}
                    <NauiCheckbox
                        label={item?.user?.full_name}
                        bind:value={item.selected}
                    />
                {/if}
            {/each}
        </div>
        </NauiExpansionPanel>
    </div>
    <div>
        <NauiExpansionPanel>
            <div slot="header">
                <div class="box-l sx-ii">
                    <NauiCheckbox
                        bind:value={roles.asistente}
                        on:change={() => {
                            filteredAsistentesAux.forEach(
                                (u) => (u.selected = roles.asistente)
                            );
                            filteredAsistentesAux = [...filteredAsistentesAux];
                        }}
                    />
                    <strong class="ml-ii"
                        >Asistente Administración de Ventas</strong
                    >
                </div>
            </div>
            <div>
                <input
                id="search3"
                class="naui-input search-input"
                placeholder="Buscar por nombre"
                type="text"
            />
            {#each filteredAsistentesAux as item}
                {#if !item?.hidden}
                    <NauiCheckbox
                        label={item?.user?.full_name}
                        bind:value={item.selected}
                    />
                {/if}
            {/each}
        </div>
        </NauiExpansionPanel>
    </div>


    <div slot="actions" class="box w-100">
        {#if editable}
            <NauiButton caption="GUARDAR"
                color="accent"
                mode="outline"
                className="min-w-300px"
                        on:click={saveItems}/>
        {/if}
    </div>

</NauiSlideOver>